/**
 * Rows of floats, one per light, volume, probe or decal, that each pack rewrites in place and
 * compares as it writes, so an unchanged pack uploads nothing.
 */
export class RowBuffer {
    rowLength;
    /** The rows, `count` of them, then unused space. */
    data;
    count = 0;
    /** Written by `append`, during a pack. Cleared by `begin`. */
    appended = 0;
    hasChanged = false;
    constructor(rowLength) {
        this.rowLength = rowLength;
        this.data = new Float32Array(rowLength);
    }
    /** Starts a pack: the rows appended next replace the ones held. */
    begin() {
        this.appended = 0;
        this.hasChanged = false;
    }
    append(row) {
        this.reserve(this.appended + 1);
        const start = this.appended * this.rowLength;
        for (let i = 0; i < this.rowLength; i++) {
            if (this.data[start + i] !== row[i])
                this.hasChanged = true;
            this.data[start + i] = row[i];
        }
        this.appended++;
    }
    /** Ends a pack, and answers whether any row changed. */
    finish() {
        const hasChanged = this.hasChanged || this.appended !== this.count;
        this.count = this.appended;
        return hasChanged;
    }
    reserve(rows) {
        if (this.data.length >= rows * this.rowLength)
            return;
        const grown = new Float32Array(rows * 2 * this.rowLength);
        grown.set(this.data);
        this.data = grown;
    }
}
//# sourceMappingURL=packedRows.js.map